import de from 'date-fns/locale/de'
import enGB from 'date-fns/locale/en-GB'
import fr from 'date-fns/locale/fr'
import it from 'date-fns/locale/it'

export const codeToLocale = [
  {
    code: 'en',
    locale: enGB
  },
  {
    code: 'fr',
    locale: fr
  },
  {
    code: 'it',
    locale: it
  },
  {
    code: 'de',
    locale: de
  }
]

export function getDateFnsLocale (lang?: string) {
  if (!lang) {
    return enGB
  }

  const locale = codeToLocale.find(({ code }) => code === lang)
  if (locale) {
    return locale?.locale
  }

  return enGB
}
